<div class="field boolean">
        <mat-form-field>
                <mat-label>User is dormant after (Months)</mat-label>
                <input matInput min="0" [formControl]="control" type="number" />
        </mat-form-field>
</div>